import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-1" }
const _hoisted_2 = {
  key: 0,
  class: "self-center mr-4 min-w-4 max-w-12"
}
const _hoisted_3 = { class: "flex flex-col self-center flex-1" }
const _hoisted_4 = { class: "text-input-label line-clamp-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-block text-m-brand line-clamp-3"
}
const _hoisted_6 = {
  key: 1,
  class: "flex self-center justify-center ml-3"
}
const _hoisted_7 = { class: "flex flex-col w-full" }
const _hoisted_8 = {
  key: 0,
  class: "self-start mb-[6px] min-w-4 max-w-12"
}
const _hoisted_9 = { class: "flex flex-row self-start items-baseline w-full" }
const _hoisted_10 = { class: "flex-1 text-input-label line-clamp-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex justify-center ml-auto pl-3"
}
const _hoisted_12 = {
  key: 1,
  class: "text-block text-m-brand line-clamp-3 mr-7"
}
const _hoisted_13 = { class: "flex flex-row flex-1" }
const _hoisted_14 = {
  key: 0,
  class: "self-center mr-4 min-w-4 max-w-12"
}
const _hoisted_15 = { class: "flex flex-col self-center" }
const _hoisted_16 = { class: "text-input-label line-clamp-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-block text-m-brand line-clamp-3"
}

import { RichText, Image, Link } from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';
import BaseIcon from '@/components/BaseIcon/BaseIcon.vue';
import { IPromoCardMini } from '@/interfaces/entities/promo-card-mini.interface';
import { MiniCardLayout } from '@/enums/card-layout.enum';
import { ButtonStyle } from '@/enums/button-style.enum';
import { mapFieldToEnum } from '@/mappers/sc-field-to-enum.mapper';
import SafeLink from '@/components/SafeLink/SafeLink.vue';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCardMini',
  props: {
    cardLayout: {},
    icon: {},
    title: {},
    description: {},
    link: {},
    showChevron: {},
    buttonStyle: {},
    greyBg: {},
    dataTestId: {},
    fullWidth: {}
  },
  setup(__props: any) {

const props = __props;

const hasIcon = computed(() => !!props.icon?.value?.src);
const showChevron = computed(() => props.showChevron?.value);
const buttonStyle = computed<ButtonStyle | undefined>(() => mapFieldToEnum(ButtonStyle, props.buttonStyle));

const buttonClass = computed(() => {
  switch (buttonStyle.value) {
    case ButtonStyle.PRIMARY:
      return ['btn-primary'];
    case ButtonStyle.TERTIARY:
      return ['btn-tertiary'];
    default:
      return ['btn-secondary']; // fallback if null, empty, or anything else
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.cardLayout === _unref(MiniCardLayout).HORIZONTAL)
      ? (_openBlock(), _createBlock(_unref(Link), {
          key: 0,
          field: _ctx.link,
          class: "group text-racq-med-grey no-underline active:no-underline"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex self-center border-[1.5px] border-solid rounded-md py-3 pr-3 pl-4 min-h-[96px] h-full shadow-md hover:shadow-xl group-active:shadow-none", _ctx.greyBg?.value ? 'bg-racq-anti-flash-white' : 'bg-racq-true-white'])
            }, [
              _createElementVNode("div", _hoisted_1, [
                (hasIcon.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_unref(Image), { media: _ctx.icon }, null, 8, ["media"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(RichText), {
                      field: _ctx.title,
                      class: "group-active:text-racq-navy group-active:underline"
                    }, null, 8, ["field"])
                  ]),
                  (_ctx.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_unref(RichText), {
                          field: _ctx.description,
                          class: "group-active:text-racq-med-grey group-active:no-underline"
                        }, null, 8, ["field"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (showChevron.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(BaseIcon, {
                        iconClass: "bg-icon-chevron",
                        class: "!w-4 !h-4"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["field"]))
      : _createCommentVNode("", true),
    (_ctx.cardLayout === _unref(MiniCardLayout).VERTICAL_STACKED)
      ? (_openBlock(), _createBlock(_unref(Link), {
          key: 1,
          field: _ctx.link,
          class: "group text-racq-med-grey no-underline active:no-underline"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex self-center border-[1.5px] border-solid rounded-md pt-3 pr-3 pb-4 pl-4 min-h-[96px] h-full shadow-md hover:shadow-xl group-active:shadow-none", _ctx.greyBg?.value ? 'bg-racq-anti-flash-white' : 'bg-racq-true-white'])
            }, [
              _createElementVNode("div", _hoisted_7, [
                (hasIcon.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_unref(Image), { media: _ctx.icon }, null, 8, ["media"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(RichText), {
                      field: _ctx.title,
                      class: "group-active:text-racq-navy group-active:underline"
                    }, null, 8, ["field"])
                  ]),
                  (showChevron.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(BaseIcon, {
                          iconClass: "bg-icon-chevron",
                          class: "!w-4 !h-4"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_unref(RichText), {
                        field: _ctx.description,
                        class: "group-active:text-racq-med-grey group-active:no-underline"
                      }, null, 8, ["field"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["field"]))
      : _createCommentVNode("", true),
    (!showChevron.value && _ctx.cardLayout === _unref(MiniCardLayout).HORIZONTAL_WITH_BUTTON)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass([
      'flex flex-col md:flex-row border-[1.5px] border-solid rounded-md pt-5 pb-4 px-4 md:p-6 w-auto md:racq-min-w-lg  min-h-[96px] shadow-md',
      _ctx.greyBg?.value ? 'bg-racq-anti-flash-white' : 'bg-racq-true-white',
      !_ctx.fullWidth?.value && 'racq-max-w-xl5',
    ])
        }, [
          _createElementVNode("div", _hoisted_13, [
            (hasIcon.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_unref(Image), { media: _ctx.icon }, null, 8, ["media"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(RichText), { field: _ctx.title }, null, 8, ["field"])
              ]),
              (_ctx.description?.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_unref(RichText), { field: _ctx.description }, null, 8, ["field"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(SafeLink, {
            field: _ctx.link,
            class: _normalizeClass(["self-center w-full md:w-max mt-5 md:mt-0 md:ml-3 active:no-underline", `btn btn-md md:btn-sm ${buttonClass.value}`])
          }, null, 8, ["field", "class"])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})